import { render, staticRenderFns } from "./PromoGrid.vue?vue&type=template&id=3a7395e4&scoped=true&"
import script from "./PromoGrid.vue?vue&type=script&lang=js&"
export * from "./PromoGrid.vue?vue&type=script&lang=js&"
import style0 from "./PromoGrid.vue?vue&type=style&index=0&id=3a7395e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7395e4",
  null
  
)

export default component.exports